
import {
  ButtonHeading,
  CommonButton,
  CustomPagination,
} from "components";
import BootstrapTable from "components/BootstrapTable";

import React, { useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";

import { Link, useNavigate } from "react-router-dom";
import LoadingBar from "react-top-loading-bar";
import StorageService from "utils/StorageServices/StorageServices";
import { UserContext } from "context";
import useDocumentTitle from "hooks/useDocumentTitle";
import { getUsablityList } from "_services/walletService/walletService";
import { utils } from "helper";


const Usabilty = () => {
  useDocumentTitle("Usablity | T360");
  const { masterData, mastersChild } = useContext(UserContext);
  const navigate = useNavigate();
  const loadingBarRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    limit: 25,
    offset: 1,
    search: "",
    status: 1,
  });

  const itemsPerPage = 25;
  const [totalItems, setTotalItems] = useState(0);
  const [usablityList, setUsablityList] = useState([])
  const [usabiltyDetails, setUsablityDetails] = useState("")

  const { subscription_data, subscription_start_date, web_end_date } = usabiltyDetails;


  const columns = [
    // { header: "", accessor: "serial" },
    { header: "Modules", accessor: "name" },
    { header: "Free Usage", accessor: "freeused" },
    { header: "Free Access", accessor: "freeAccess" },
    { header: "Charges", accessor: "chargesof" },
    { header: "Paid Usage", accessor: "total_paid" },
    { header: "Total Usages", accessor: "totalUses" },
    { header: "Max Usages", accessor: "masUses" },
  ];

  const usageDurationOptions = {
    1: "Daily",
    2: "Monthly",
    3: "Yearly"
  }

  useEffect(() => {
    getAddressBookList()
  }, []);


  const getAddressBookList = async () => {
    try {
      if (loadingBarRef.current) {
        loadingBarRef.current.continuousStart(); // Start the loading bar
      }
      let object = {
        // ...filter,
        company_id: StorageService.getCompanyId(),
      };

      const res = await getUsablityList(object)
      if (res?.responseCode == 200) {
        setUsablityList(res?.data?.company?.subscription_data?.usability)
        setUsablityDetails(res?.data?.company)

      }

    } catch (error) {
      toast.error(error);
    } finally {
      if (loadingBarRef.current) {
        loadingBarRef.current.complete();
      }
    }
  };


  const rowListData = (data) => {
    return data?.map((item, i) => ({
      ...item,
      chargesof: item?.charges ? `₹ ${item?.charges}` : "0",
      total_paid: item?.total_paid_usage ? `${item?.total_paid_usage}` : 0,
      freeAccess: item?.free_access ? `${item?.free_access} ${usageDurationOptions[item?.usage_access]}` : `0 ${usageDurationOptions[item?.usage_access]}`,
      freeused: item?.free_used ? item?.free_used : 0,
      totalUses: item?.total_free_usage || 0,
      masUses: item?.max_usage ? item?.max_usage : 0,

    }));
  };

  const handlePageChange = (page) => {
    setFilter((s) => ({ ...s, offset: page }));
  };


  const calculateRemainingDays = (endDate) => {
    if (!endDate) return 0;

    const today = new Date();
    const end = new Date(endDate);
    const diffMs = end - today;
    const diffDays = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    return diffDays >= 0 ? diffDays : 0;
  };

  const days = calculateRemainingDays(web_end_date)

  return (
    <div>
      <LoadingBar
        color="#ffa800"
        ref={loadingBarRef}
        height={4}
        shadow={true}
        loaderSpeed={1000}
      />
      {/* <ButtonHeading
        title={"Address Book"}
      // onClick={() => setShowOffcanvas(true)}
      // buttonTitle={masterChildAddressBook?.create === 1 && "Add Address Book"}
      // showSearchFilter={{
      //   search: true,
      //   filterOption: false,
      //   filterCount: true,
      // }}
      // onClickFilterModal={(e) => setShowFilterModal(false)}
      // filter={filter}
      // setFilter={setFilter}
      // isDebouncedSearch={true}
      /> */}


      <div className="__mainUtility_bxs">
        <div className='__payM_head'><h6>Usability</h6></div>
        {/* <div className="__subsMain">
          <div className="subscription-card">
            <div className="subscription-header">
              <span className="subscription-title">Current Subscription Status</span>
              <div className="wallet-section">
                <span className="wallet-balance">Wallet Balance ₹ 0</span>
                <CommonButton
                  className="anime-btn _addComm_btn"
                  buttonTitle="Recharge Wallet"
                  onClick={() => navigate("/wallet")}
                />
              </div>
            </div>

            <div className="subscription-details">
              {[
                { label: "Subscription", value: subscription_data?.plan_type },
                { label: "Subscription Start Date", value: `${utils?.getDateByApiResponse(subscription_start_date,"/")}` },
                { label: "Subscription End Date", value: `${utils?.getDateByApiResponse(web_end_date,"/")} (${days} ${days == (0 || 1) ? "day" : "days"})` },
                { label: "Monthly Price", value: `₹ ${subscription_data?.monthly_rate || 0}` },
                { label: "Users", value: `${usabiltyDetails?.user_count || 0}/ ${subscription_data?.max_no_of_user || 0} ` },
                { label: "Branch", value: `${usabiltyDetails?.branch_count || 0} /${subscription_data?.no_of_branch || 0}` },
              ].map((item, idx) => (
                <div key={idx} className="detail-row">
                  <span className="detail-label">{item.label}:</span>
                  <p className="detail-value">{item.value}</p>
                </div>
              ))}
            </div>
          </div>
        </div> */}
        <BootstrapTable
          tableClass="utilityTbl_bxs"
          columns={columns}
          data={rowListData(usablityList?.length ? usablityList : [])}
          isLoading={loading}
        />


      </div>
      <style>
        {`
        .__mainUtility_bxs {
        display: flex;
        flex-direction:column;
        height: calc(100vh - 109px);
        overflow: auto;
        }
        .__subsMain {
        padding: 11px 14px 0px;
        }
        .utilityTbl_bxs {
          overflow: auto;
          flex: 1;
        /*padding: 0px 14px 15px;*/
        }
        .utilityTbl_bxs ._tab_htLane {
          height: 100%;
          overflow: auto;
        }
          .utilityTbl_bxs ._tab_htLane .anv_fr_detailHead {
            height: 100%;
            overflow: auto;
          }
        .subscription-card {
  border: 1px solid #E8E7E7;
  height: 221px;
  margin: 0px;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  overflow: hidden;
}

.subscription-header {
  height: 40px;
  border-bottom: 1px solid #E8E7E7;
  background: #FAFAFA;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 12px;
}

.subscription-title {
  font-size: 14px;
  color: #001B50;
  font-weight: 400;
}

.wallet-section {
  display: flex;
  align-items: center;
  gap: 10px;
}

.wallet-balance {
  font-size: 14px;
  color: #001B50;
  font-weight: 500;
}

.subscription-details {
  display: flex;
  flex-direction: column;
  margin: 12px;
  gap: 5px;
}

.detail-row {
  display: flex;
  gap: 5px;
}

.detail-label {
  font-size: 14px;
  color: #001B50;
  font-weight: 500;
}

.detail-value {
  font-size: 14px;
  font-weight: 400;
  margin: 0;
}
`}
      </style>
    </div>

  );
};

export default Usabilty;
